import './MonitorNotifications.scss';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import { MonitoringSchedule } from '@sonar-software/sonar-core';
import { SonarStakeholder } from '@ui/SonarStakeholder';
import { SonarText } from '@ui/text';
import { StakeholderSelector } from '@ui/StakeholderSelector';
import { usePrevious } from '@hooks';
import { COPY_SPECIFIC, SETTINGS_DATA_SECURITY_COPY } from '@sonar-software/sonar-ts-constants';
import { Else, If, Then, When } from 'react-if';
import { Form, Radio, Space } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
export const MonitorNotifications = ({ editing, fieldId, stakeholderIds = [], schedule }) => {
    const [emails, setEmails] = useState(stakeholderIds);
    const previousIds = usePrevious(stakeholderIds, stakeholderIds);
    const emailsSelected = emails.length > 0;
    const handleChange = useCallback((ids) => {
        setEmails(ids);
    }, []);
    useEffect(() => {
        if (!isEqual(stakeholderIds, previousIds)) {
            setEmails(stakeholderIds);
        }
    }, [stakeholderIds, previousIds]);
    return (React.createElement("div", { className: 'app-monitor-notifications' },
        React.createElement(SonarText, { className: classNames('h3', 'app-monitor-notifications-title'), weight: 'semibold' }, SETTINGS_DATA_SECURITY_COPY.NOTIFICATION_SETTINGS),
        React.createElement("div", { className: 'app-monitor-notifications-schedule' },
            React.createElement(If, { condition: editing },
                React.createElement(Then, null,
                    React.createElement(Form.Item, { className: 'monitor-email-to', id: 'monitor-email-to', initialValue: emails, label: COPY_SPECIFIC.EMAIL, name: fieldId === undefined ? 'stakeholderIds' : [fieldId, 'stakeholderIds'], validateTrigger: ['onChange', 'onBlur'] },
                        React.createElement(StakeholderSelector, { direction: 'horizontal', mode: 'multiple', onChange: handleChange, placeholder: COPY_SPECIFIC.SELECT_USER })),
                    React.createElement(When, { condition: emailsSelected },
                        React.createElement(Form.Item, { className: 'monitor-schedule-options', hidden: true, initialValue: MonitoringSchedule.Immediately, name: fieldId === undefined ?
                                'notificationSchedule' :
                                [fieldId, 'notificationSchedule'] },
                            React.createElement(Radio.Group, { className: 'monitor-schedule-options-items', options: Object.values(MonitoringSchedule), size: 'small', value: schedule !== null && schedule !== void 0 ? schedule : MonitoringSchedule.Immediately })))),
                React.createElement(Else, null,
                    React.createElement(If, { condition: emailsSelected },
                        React.createElement(Then, null,
                            React.createElement("div", { className: 'monitor-email-to' },
                                React.createElement(SonarText, null, COPY_SPECIFIC.EMAIL),
                                React.createElement(Space, { className: 'monitor-schedule-selection', direction: 'horizontal', wrap: true }, emails === null || emails === void 0 ? void 0 : emails.map((id) => React.createElement(SonarStakeholder, { key: id, showTooltip: true, stakeholderId: id }))))),
                        React.createElement(Else, null,
                            React.createElement(SonarText, { className: 'app-monitor-no-notifications' }, SETTINGS_DATA_SECURITY_COPY.NO_NOTIFICATIONS))))))));
};
